export function jsonClean(jsonString: string): string {
	return jsonString
		.replace(/^```json/, "")
		.replace(/```$/, "")
		.replace(/``` +$/, "")
		.replace(/^"""/, "")
		.replace(/"""$/, "")
		.replace(/""" +$/, "");
}
